const pageData = [
    {
        id: 'learn',
        title: 'Learn Scrawl-canvas',
        tabTitle: 'Scrawl-canvas Learn',
        description: 'A brief introduction into adding Scrawl-canvas to a project, and building HTML5 canvas element displays and animations using it.',
    }, 
    {
        id: 'how-do-i',
        title: 'Scrawl-canvas ~How Do I?~ Cookbook',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Blog articles detailing some approaches to building various displays and animations in an HTML5 canvas element using Scrawl-canvas.',
    }, 
    {
        id: 'documentation',
        title: 'Scrawl-canvas Documentation',
        tabTitle: 'Scrawl-canvas Docs',
        description: 'HTML pages documenting the Scrawl-canvas code base, generated from inline comments in the code.',
    }, 
    {
        id: 'demonstrations',
        title: 'Scrawl-canvas Test Demos',
        tabTitle: 'Scrawl-canvas Demo',
        description: 'A suite of interactive HTML5 canvas demonstration displays and animations, used to test the code underlying the Scrawl-canvas library.',
    }, 
    {
        id: 'error',
        title: 'Scrawl-canvas Page Load Error',
        tabTitle: 'Scrawl-canvas Error',
        description: 'Failed to find page, or load page resources',
    }, 
    {
        id: 'privacy-and-cookies',
        title: 'Scrawl-canvas Privacy, Security and Cookies page',
        tabTitle: 'Scrawl-canvas Privacy',
        description: 'Details of cookies used on the site.',
    }, 
];

export default pageData;
